/**
 * Gradient-filled progress bar — Aurora's signature device. The track
 * and fill are styled by the `.aurora-progress-bar` / `.aurora-progress-fill`
 * classes from tokens.css so the gradient stays consistent across
 * themes. Pure CSS transition on the fill width.
 */
export function ProgressBar({
  value,
  total,
  ariaLabel,
  className = '',
}: {
  value: number;
  total: number;
  ariaLabel?: string;
  className?: string;
}) {
  const pct = total > 0 ? Math.min(100, Math.max(0, (value / total) * 100)) : 0;
  return (
    <div
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={total}
      aria-label={ariaLabel}
      className={`aurora-progress-bar ${className}`}
    >
      <div className="aurora-progress-fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
